import Highcharts from "../highcharts_config";

export default function renderChart (data) {
  const colors = [
    "#DC2626",
    "#55B686",
  ]

  const chartContainer = document.getElementById("workplace-compliance-chart");

  if (!chartContainer) return;

  chartContainer.setAttribute("style", null)

  Highcharts.chart(chartContainer.id, {
    credits: {
      enabled: false,
    },
    chart: {
      type: "column",
    },
    title: {
      text: data.name,
      align: "left",
      margin: 30,
      style: {
        fontWeight: "bold"
      }
    },
    xAxis: {
      categories: data.categories,
      title: {
        text: null,
      },
      style: {
        marginTop: 20
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      min: 0,
      gridLineDashStyle: 'shortdash',
      title: {
        text: null,
      },
      opposite: true,
      labels: {
        format: '{value} %'
      },
      stackLabels: {
        enabled: false,
        style: {
          fontWeight: "bold",
          color: ( // theme
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color
          ) || "gray"
        }
      },
    },
    legend: {
      enabled: false
    },
    tooltip: {
      backgroundColor: "#000",
      borderColor: "#000",
      borderRadius: 15,
      style: {
        color: "#fff",
      },
      headerFormat: "<b>{point.x}</b><br/><br/>",
      pointFormat: "{series.name}: {point.y:,.0f}<br/>Total: {point.stackTotal}",
    },
    plotOptions: {
      column: {
        borderWidth: 1,
        stacking: "percent",
        dataLabels: {
          enabled: false
        }
      }
    },
    series: data.series.map((series,i) => {
      series.color = colors[i]
      series.borderColor = colors[i]
      return series
    })
  })
}
